import style from './Loader.module.css';

export const Loader = () => {
  return <span className={style.loader}></span>;
};
